import React, {Component, Fragment} from 'react';
import {observer,inject} from "mobx-react";
import {StoreContext} from "../../stores/contexts";

class ItemsPerPage extends Component {
  static contextType = StoreContext;

  render() {
    const pages=this.context.dataStore.data.data.pages;
    return (
      <div className="up12 splice itemsPerPageGrid">
        <div className="cell s-shrink ttu bold fs12 s-middle">
          Выводить по
        </div>
        <div className="cell s-shrink pleft10">
          <span className="select">
            <select onChange={(e)=>{ this.context.memoryStore.setItemsPerPage(e.target.value); }} value={this.context.memoryStore.memory.items_per_page}>
              <option value="20">20</option>
              <option value="50">50</option>
              <option value="100">100</option>
              <option value="1000">1000</option>
            </select>
          </span>
        </div>
        {pages?(
          <>
            <div className="cell s-shrink ttu bold fs12 s-middle pleft20">
              Всего:
            </div>
            <div className="w5 s-middle cell s-shrink pleft10">
             {pages.rows}
            </div>
          </>
        ):null}
      </div>
    )
  }
}

// export default inject("memoryStore","dataStore")(observer(ItemsPerPage));
export default observer(ItemsPerPage);